import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-profile-leaderboard",
    templateUrl: "./profile-leaderboard.component.html",
    styleUrls: ["./profile-leaderboard.component.scss"]
})
export class ProfileLeaderboardComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
